import { Partner } from 'interfaces/partner'
import Link from 'lib/components/link/link'

export default function ProjectPartnerContent({ partner }: { partner: Partner }) {
  return (
    <div className="tw-flex tw-items-center tw-gap-1">
      <img className="tw-h-8 tw-w-8 tw-rounded-md" src={partner?.logo} alt={partner?.name} />
      <span>{partner?.label}</span>
      <Link
        href={partner?.link}
        target="_blank"
        className="tw-text-sm tw-text-neutral-500 tw-underline"
        data-testid="partner-link"
      >
        {partner?.name}
      </Link>
      <Link
        href={partner?.blogPostLink}
        target="_blank"
        externalIcon
        className="tw-text-sm"
        data-testid="partner-blog-post-link"
      >
        Learn More
      </Link>
    </div>
  )
}
